import type { BreadcrumbConfig } from '../../../../types/templates';

const fields = ['stage', 'adChannel', 'variant', 'cta_enabled', 'subheadline_enabled', 'legal'] as const;

type MacroFields = (typeof fields)[number];

export const MACRO_BREADCRUMB_CONFIG: BreadcrumbConfig<MacroFields> = {
  fields: ['stage', 'adChannel', 'variant', 'cta_enabled', 'subheadline_enabled', 'legal'],

  labels: {
    stage: 'Etapa',
    adChannel: 'Medio',
    variant: 'Motivo',
    cta_enabled: 'CTA',
    subheadline_enabled: 'Bajada',
    legal: 'Legal'
  },

  formatters: {
    stage: value => {
      const stageNames: Record<string, string> = {
        CONVERSION: 'Conversión',
        CONSIDERACION: 'Consideración',
        AWARENESS: 'Awareness'
      };
      return stageNames[value] || value;
    },

    adChannel: value => {
      const channelNames: Record<string, string> = {
        google: 'Google Ads',
        meta: 'Meta Ads'
      };
      return channelNames[value] || value;
    },

    variant: value => `Motivo ${value}`,

    cta_enabled: value => (value === 'si' ? 'CTA' : null),
    subheadline_enabled: value => (value === 'si' ? 'Bajada' : null),
    legal: value => (value === 'si' ? 'Legal' : null)
  }
};
